import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaCheck, FaTimes, FaCrown, FaStar, FaGem, FaRocket, FaShieldAlt,
  FaComments, FaWhatsapp, FaSearch, FaEye, FaHeadset, FaRobot,
  FaBolt, FaChevronDown, FaChevronUp, FaSpinner
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

// Plan features
const plans = [
  {
    id: 'basic',
    name: 'Basic',
    nameMarathi: 'बेसिक',
    price: 1000,
    duration: '/महिना',
    color: 'border-gray-200',
    bgColor: 'bg-white',
    headerBg: 'bg-[#FFF8F0]',
    headerText: 'text-[#8B0000]',
    buttonBg: 'bg-[#8B0000] hover:bg-[#DC143C]',
    icon: FaStar,
    recommended: false,
    features: [
      { text: 'प्रोफाइल लिस्टिंग', included: true },
      { text: 'बेसिक सर्च', included: true },
      { text: '10 प्रोफाइल व्ह्यूज/महिना', included: true },
      { text: 'रस व्यक्त करा (5/दिवस)', included: true },
      { text: 'अमर्यादित प्रोफाइल व्ह्यूज', included: false },
      { text: 'चॅट सुविधा', included: false },
      { text: 'WhatsApp नोटिफिकेशन', included: false },
      { text: 'प्राधान्य सपोर्ट', included: false },
      { text: 'AI मॅचमेकिंग', included: false },
      { text: 'प्रोफाइल बूस्ट', included: false },
    ]
  },
  {
    id: 'premium',
    name: 'Premium',
    nameMarathi: 'प्रीमियम',
    price: 1500,
    duration: '/महिना',
    color: 'border-[#FFD700]',
    bgColor: 'bg-white',
    headerBg: 'bg-gradient-to-r from-[#FFD700] to-[#B8860B]',
    headerText: 'text-[#8B0000]',
    buttonBg: 'bg-gradient-to-r from-[#FFD700] to-[#B8860B] hover:from-[#B8860B] hover:to-[#FFD700] text-[#8B0000]',
    icon: FaCrown,
    recommended: true,
    features: [
      { text: 'प्रोफाइल लिस्टिंग', included: true },
      { text: 'अ‍ॅडव्हान्स्ड सर्च', included: true },
      { text: 'अमर्यादित प्रोफाइल व्ह्यूज', included: true },
      { text: 'अमर्यादित रस व्यक्त करा', included: true },
      { text: 'चॅट सुविधा', included: true },
      { text: 'WhatsApp नोटिफिकेशन', included: true },
      { text: 'प्राधान्य सपोर्ट', included: true },
      { text: 'संपर्क माहिती पहा', included: true },
      { text: 'AI मॅचमेकिंग', included: false },
      { text: 'प्रोफाइल बूस्ट', included: false },
    ]
  },
  {
    id: 'royal',
    name: 'Royal',
    nameMarathi: 'रॉयल',
    price: 2000,
    duration: '/महिना',
    color: 'border-[#8B0000]',
    bgColor: 'bg-white',
    headerBg: 'bg-gradient-to-r from-[#8B0000] to-[#DC143C]',
    headerText: 'text-[#FFD700]',
    buttonBg: 'bg-[#8B0000] hover:bg-[#DC143C]',
    icon: FaGem,
    recommended: false,
    features: [
      { text: 'प्रोफाइल लिस्टिंग', included: true },
      { text: 'अ‍ॅडव्हान्स्ड सर्च', included: true },
      { text: 'अमर्यादित प्रोफाइल व्ह्यूज', included: true },
      { text: 'अमर्यादित रस व्यक्त करा', included: true },
      { text: 'चॅट सुविधा', included: true },
      { text: 'WhatsApp नोटिफिकेशन', included: true },
      { text: 'प्राधान्य सपोर्ट', included: true },
      { text: 'संपर्क माहिती पहा', included: true },
      { text: 'AI मॅचमेकिंग', included: true },
      { text: 'प्रोफाइल बूस्ट', included: true },
      { text: 'सर्चमध्ये प्राधान्य', included: true },
      { text: 'डेडिकेटेड रिलेशनशिप मॅनेजर', included: true },
    ]
  }
];

const comparisonFeatures = [
  { feature: 'प्रोफाइल लिस्टिंग', basic: true, premium: true, royal: true },
  { feature: 'सर्च फिल्टर्स', basic: 'बेसिक', premium: 'अ‍ॅडव्हान्स्ड', royal: 'अ‍ॅडव्हान्स्ड' },
  { feature: 'प्रोफाइल व्ह्यूज', basic: '10/महिना', premium: 'अमर्यादित', royal: 'अमर्यादित' },
  { feature: 'रस व्यक्त करा', basic: '5/दिवस', premium: 'अमर्यादित', royal: 'अमर्यादित' },
  { feature: 'चॅट', basic: false, premium: true, royal: true },
  { feature: 'WhatsApp नोटिफिकेशन', basic: false, premium: true, royal: true },
  { feature: 'संपर्क माहिती', basic: false, premium: true, royal: true },
  { feature: 'प्राधान्य सपोर्ट', basic: false, premium: true, royal: true },
  { feature: 'AI मॅचमेकिंग', basic: false, premium: false, royal: true },
  { feature: 'प्रोफाइल बूस्ट', basic: false, premium: false, royal: true },
  { feature: 'सर्चमध्ये प्राधान्य', basic: false, premium: false, royal: true },
  { feature: 'रिलेशनशिप मॅनेजर', basic: false, premium: false, royal: true },
];

const faqs = [
  {
    q: 'सदस्यता कशी खरेदी करावी?',
    a: 'तुमच्या पसंतीची योजना निवडा आणि "निवडा" बटण दाबा. ऑनलाइन पेमेंट करून सदस्यता सुरू करा.'
  },
  {
    q: 'सदस्यता कधीही रद्द करता येते का?',
    a: 'होय, तुम्ही कधीही सदस्यता रद्द करू शकता. रद्द केल्यानंतर वर्तमान कालावधी पूर्ण होईपर्यंत सुविधा उपलब्ध राहतील.'
  },
  {
    q: 'पेमेंट सुरक्षित आहे का?',
    a: 'होय, आमचे सर्व पेमेंट SSL एन्क्रिप्टेड आहेत. आम्ही Razorpay सारख्या विश्वासार्ह पेमेंट गेटवेचा वापर करतो.'
  },
  {
    q: 'रिफंड पॉलिसी काय आहे?',
    a: 'खरेदीनंतर 7 दिवसांच्या आत रिफंड विनंती करता येते, जर तुम्ही कोणतीही premium सुविधा वापरली नसेल.'
  },
  {
    q: 'एकापेक्षा जास्त महिन्यांची सदस्यता घेता येते का?',
    a: 'होय, 3 महिने, 6 महिने आणि 12 महिन्यांच्या योजना उपलब्ध आहेत, ज्यात अतिरिक्त सवलत मिळते.'
  }
];

// Pricing Card
const PricingCard = ({ plan, onSelect, processing }) => (
  <div className={`relative ${plan.bgColor} rounded-2xl shadow-lg border-2 ${plan.color} overflow-hidden transition-all duration-300 hover:shadow-2xl ${
    plan.recommended ? 'transform scale-105 z-10' : 'hover:-translate-y-1'
  }`}>
    {plan.recommended && (
      <div className="absolute -top-0 left-0 right-0 bg-[#DC143C] text-white text-center py-1.5 text-xs font-bold font-['Noto_Sans_Devanagari'] tracking-wider">
        सर्वात लोकप्रिय
      </div>
    )}

    {/* Header */}
    <div className={`${plan.headerBg} px-6 py-6 text-center ${plan.recommended ? 'pt-10' : ''}`}>
      <plan.icon className={`text-3xl mx-auto mb-2 ${plan.headerText}`} />
      <h3 className={`text-2xl font-bold ${plan.headerText} font-['Playfair_Display']`}>{plan.name}</h3>
      <p className={`text-sm ${plan.headerText} opacity-80 font-['Noto_Sans_Devanagari']`}>{plan.nameMarathi}</p>
      <div className="mt-4">
        <span className={`text-4xl font-bold ${plan.headerText}`}>₹{plan.price}</span>
        <span className={`text-sm ${plan.headerText} opacity-70 font-['Noto_Sans_Devanagari']`}>{plan.duration}</span>
      </div>
    </div>

    {/* Features */}
    <div className="px-6 py-6">
      <ul className="space-y-3">
        {plan.features.map((feature, idx) => (
          <li key={idx} className="flex items-center gap-3 text-sm">
            {feature.included ? (
              <FaCheck className="text-green-500 flex-shrink-0" />
            ) : (
              <FaTimes className="text-gray-300 flex-shrink-0" />
            )}
            <span className={`font-['Noto_Sans_Devanagari'] ${feature.included ? 'text-gray-700' : 'text-gray-400'}`}>
              {feature.text}
            </span>
          </li>
        ))}
      </ul>

      <button
        onClick={() => onSelect(plan)}
        disabled={processing}
        className={`w-full mt-6 py-3 rounded-xl font-bold text-sm transition-all shadow-md hover:shadow-lg ${plan.buttonBg} ${
          plan.id === 'premium' ? '' : 'text-white'
        } disabled:opacity-50 font-['Noto_Sans_Devanagari']`}
      >
        {processing ? (
          <FaSpinner className="animate-spin inline mr-2" />
        ) : null}
        निवडा
      </button>
    </div>
  </div>
);

// FAQ Item
const FAQItem = ({ faq, isOpen, onToggle }) => (
  <div className="border border-gray-200 rounded-xl overflow-hidden">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between px-5 py-4 bg-white hover:bg-gray-50 transition-colors text-left"
    >
      <span className="font-semibold text-gray-800 text-sm font-['Noto_Sans_Devanagari']">{faq.q}</span>
      {isOpen ? <FaChevronUp className="text-[#8B0000] flex-shrink-0" /> : <FaChevronDown className="text-gray-400 flex-shrink-0" />}
    </button>
    {isOpen && (
      <div className="px-5 py-4 bg-[#FFF8F0] border-t border-gray-100">
        <p className="text-sm text-gray-600 leading-relaxed font-['Noto_Sans_Devanagari']">{faq.a}</p>
      </div>
    )}
  </div>
);

const PricingPage = () => {
  const { api, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [processing, setProcessing] = useState(false);
  const [openFAQ, setOpenFAQ] = useState(null);
  const [showPayment, setShowPayment] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const handleSelectPlan = async (plan) => {
    if (!isAuthenticated) {
      toast.info('कृपया प्रथम लॉगिन करा');
      navigate('/login');
      return;
    }

    setSelectedPlan(plan);
    setProcessing(true);

    try {
      const response = await api.post('/api/subscriptions/create-order', {
        planId: plan.id,
        amount: plan.price
      });
      setShowPayment(true);
      toast.info('पेमेंट पेज उघडत आहे...');
    } catch (error) {
      console.error('Failed to create order:', error);
      // Show payment simulation anyway
      setShowPayment(true);
    } finally {
      setProcessing(false);
    }
  };

  const handlePaymentSimulation = async (success) => {
    if (success) {
      try {
        await api.post('/api/subscriptions/confirm', {
          planId: selectedPlan.id,
          paymentId: 'SIM_' + Date.now()
        });
        toast.success('सदस्यता यशस्वीरित्या सक्रिय!');
        navigate('/my-profile');
      } catch (error) {
        toast.success('सदस्यता सक्रिय! (Simulated)');
        navigate('/my-profile');
      }
    } else {
      toast.error('पेमेंट रद्द केले');
    }
    setShowPayment(false);
    setSelectedPlan(null);
  };

  return (
    <div className="min-h-screen bg-[#FFF8F0] flex flex-col">
      <Navbar />

      {/* Hero */}
      <div className="bg-gradient-to-br from-[#8B0000] via-[#8B0000] to-[#DC143C] py-12 md:py-16 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-[#FFD700] rounded-full" />
          <div className="absolute bottom-10 right-10 w-48 h-48 border-2 border-[#FFD700] rounded-full" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 border border-[#FFD700] rounded-full" />
        </div>
        <div className="max-w-4xl mx-auto px-4 relative z-10">
          <div className="inline-flex items-center gap-2 bg-[#FFD700]/20 text-[#FFD700] px-4 py-1.5 rounded-full text-sm font-medium mb-4">
            <FaCrown /> Premium Membership
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white font-['Noto_Sans_Devanagari'] mb-3">
            सदस्यता योजना
          </h1>
          <p className="text-[#FFD700]/80 text-base md:text-lg font-['Noto_Sans_Devanagari'] max-w-xl mx-auto">
            तुमच्या जोडीदाराच्या शोधासाठी योग्य योजना निवडा
          </p>
        </div>
      </div>

      {/* Pricing Cards */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 items-start">
          {plans.map(plan => (
            <PricingCard
              key={plan.id}
              plan={plan}
              onSelect={handleSelectPlan}
              processing={processing}
            />
          ))}
        </div>
      </div>

      {/* Feature Comparison Table */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-2xl font-bold text-[#8B0000] text-center font-['Noto_Sans_Devanagari'] mb-8">
          योजनांची तुलना
        </h2>
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-[#8B0000]">
                  <th className="text-left px-5 py-4 text-white text-sm font-['Noto_Sans_Devanagari']">सुविधा</th>
                  <th className="text-center px-5 py-4 text-white text-sm font-['Playfair_Display']">Basic</th>
                  <th className="text-center px-5 py-4 text-[#FFD700] text-sm font-['Playfair_Display']">Premium</th>
                  <th className="text-center px-5 py-4 text-[#FFD700] text-sm font-['Playfair_Display']">Royal</th>
                </tr>
              </thead>
              <tbody>
                {comparisonFeatures.map((row, idx) => (
                  <tr key={idx} className={`border-b border-gray-50 ${idx % 2 === 0 ? 'bg-[#FFF8F0]/50' : ''}`}>
                    <td className="px-5 py-3 text-sm text-gray-700 font-['Noto_Sans_Devanagari']">{row.feature}</td>
                    {['basic', 'premium', 'royal'].map(plan => (
                      <td key={plan} className="text-center px-5 py-3">
                        {row[plan] === true ? (
                          <FaCheck className="text-green-500 mx-auto" />
                        ) : row[plan] === false ? (
                          <FaTimes className="text-gray-300 mx-auto" />
                        ) : (
                          <span className="text-sm text-gray-600 font-['Noto_Sans_Devanagari']">{row[plan]}</span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
                <tr className="bg-[#FFF8F0]">
                  <td className="px-5 py-4 font-bold text-[#8B0000] font-['Noto_Sans_Devanagari']">किंमत</td>
                  <td className="text-center px-5 py-4 font-bold text-gray-800">₹1000/महिना</td>
                  <td className="text-center px-5 py-4 font-bold text-[#B8860B]">₹1500/महिना</td>
                  <td className="text-center px-5 py-4 font-bold text-[#8B0000]">₹2000/महिना</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Trust Indicators */}
      <div className="bg-white py-12 border-y border-gray-100">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {[
              { icon: FaShieldAlt, label: 'सुरक्षित पेमेंट', sub: 'SSL Encrypted' },
              { icon: FaHeadset, label: '24/7 सपोर्ट', sub: 'Customer Support' },
              { icon: FaRobot, label: 'AI मॅचमेकिंग', sub: 'Smart Matching' },
              { icon: FaBolt, label: 'झटपट सक्रिय', sub: 'Instant Activation' },
            ].map((item, idx) => (
              <div key={idx} className="space-y-2">
                <div className="w-12 h-12 bg-[#8B0000]/10 rounded-full flex items-center justify-center mx-auto">
                  <item.icon className="text-[#8B0000] text-xl" />
                </div>
                <p className="font-semibold text-gray-800 text-sm font-['Noto_Sans_Devanagari']">{item.label}</p>
                <p className="text-xs text-gray-500">{item.sub}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* FAQ */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="text-2xl font-bold text-[#8B0000] text-center font-['Noto_Sans_Devanagari'] mb-8">
          वारंवार विचारले जाणारे प्रश्न
        </h2>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <FAQItem
              key={idx}
              faq={faq}
              isOpen={openFAQ === idx}
              onToggle={() => setOpenFAQ(openFAQ === idx ? null : idx)}
            />
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="bg-gradient-to-r from-[#8B0000] to-[#DC143C] py-12">
        <div className="max-w-3xl mx-auto px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white font-['Noto_Sans_Devanagari'] mb-3">
            आजच सुरू करा
          </h2>
          <p className="text-[#FFD700]/80 font-['Noto_Sans_Devanagari'] mb-6">
            तुमच्या आयुष्याचा जोडीदार शोधण्यासाठी पहिले पाऊल टाका
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="bg-[#FFD700] text-[#8B0000] px-8 py-3 rounded-xl font-bold text-lg hover:bg-[#B8860B] hover:text-white transition-all shadow-lg hover:shadow-xl font-['Noto_Sans_Devanagari']"
          >
            योजना निवडा
          </button>
        </div>
      </div>

      {/* Payment Simulation Modal */}
      {showPayment && (
        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
            <div className="bg-gradient-to-r from-[#8B0000] to-[#DC143C] px-6 py-5 text-center">
              <FaCrown className="text-[#FFD700] text-3xl mx-auto mb-2" />
              <h3 className="text-white font-bold text-lg font-['Playfair_Display']">{selectedPlan?.name} Plan</h3>
              <p className="text-[#FFD700] text-2xl font-bold mt-1">₹{selectedPlan?.price}</p>
            </div>

            <div className="p-6 space-y-4">
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-center">
                <p className="text-yellow-800 text-sm font-['Noto_Sans_Devanagari']">
                  हे पेमेंट सिम्युलेशन आहे. प्रत्यक्ष पेमेंट गेटवे लवकरच जोडले जाईल.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600 font-['Noto_Sans_Devanagari']">योजना</span>
                  <span className="font-medium">{selectedPlan?.name}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-gray-600 font-['Noto_Sans_Devanagari']">कालावधी</span>
                  <span className="font-medium">1 महिना</span>
                </div>
                <div className="flex justify-between text-sm border-t border-gray-200 pt-2">
                  <span className="font-bold text-gray-800 font-['Noto_Sans_Devanagari']">एकूण</span>
                  <span className="font-bold text-[#8B0000]">₹{selectedPlan?.price}</span>
                </div>
              </div>

              <div className="flex gap-3">
                <button
                  onClick={() => handlePaymentSimulation(false)}
                  className="flex-1 py-3 border border-gray-300 rounded-xl text-gray-600 font-medium hover:bg-gray-50 transition-colors font-['Noto_Sans_Devanagari']"
                >
                  रद्द करा
                </button>
                <button
                  onClick={() => handlePaymentSimulation(true)}
                  className="flex-1 py-3 bg-green-600 text-white rounded-xl font-bold hover:bg-green-700 transition-colors font-['Noto_Sans_Devanagari']"
                >
                  पेमेंट करा ₹{selectedPlan?.price}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default PricingPage;
